/**
 * useDrillDown — owns the drill-down navigation stack for one dashboard
 * section. Sections call openLedger()/openVoucher() from a row click and
 * render <DrillDownModal {...drill} /> with the result.
 *
 * A stack rather than a single target so Trial Balance -> Ledger -> Voucher
 * can walk back a level instead of closing outright.
 */

import { useCallback, useState } from 'react';

export const useDrillDown = () => {
  const [stack, setStack] = useState([]);

  const openLedger = useCallback(({ companyId, ledgerGuid, ledgerName, from, to }) => {
    if (!companyId || (!ledgerGuid && !ledgerName)) return;
    setStack([{ type: 'ledger', companyId, ledgerGuid, ledgerName, from, to }]);
  }, []);

  const openVoucher = useCallback(({ companyId, guid, label }) => {
    if (!companyId || !guid) return;
    setStack([{ type: 'voucher', companyId, guid, label }]);
  }, []);
const openInventory = useCallback(({ companyId }) => {
    if (!companyId) return;

    setStack([
        {
            type: "inventory",
            companyId
        }
    ]);
}, []);
  const push = useCallback((level) => setStack((s) => [...s, level]), []);

  const popTo = useCallback((index) => {
    setStack((s) => (index < 0 ? [] : s.slice(0, index + 1)));
  }, []);

  const close = useCallback(() => setStack([]), []);

  return { stack, isOpen: stack.length > 0, openLedger, openVoucher,openInventory, push, popTo, close };
};

export default useDrillDown;
